import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import {
  computeSignupFunnel,
  type FunnelInputRoom,
  type FunnelInputUser,
  type SignupFunnel,
} from "../utils/signupFunnel";

export type { FunnelUser, SignupFunnel } from "../utils/signupFunnel";

export async function getSignupFunnel(): Promise<SignupFunnel> {
  const [usersSnapshot, roomsSnapshot] = await Promise.all([
    getDocs(collection(db, "users")),
    getDocs(collection(db, "rooms")),
  ]);

  const users: FunnelInputUser[] = usersSnapshot.docs.map((userDoc) => {
    const data = userDoc.data() as { name?: string; email?: string };
    return { uid: userDoc.id, name: data.name, email: data.email };
  });

  const rooms: FunnelInputRoom[] = roomsSnapshot.docs.map((roomDoc) => {
    const data = roomDoc.data() as {
      createdBy?: string;
      participants?: unknown;
    };
    return {
      createdBy: data.createdBy,
      participants: Array.isArray(data.participants)
        ? data.participants.filter(
            (uid): uid is string => typeof uid === "string",
          )
        : [],
    };
  });

  return computeSignupFunnel(users, rooms);
}
